module.exports = __webpack_public_path__ + "img/power-armor.7a97c193.png";